import script from "./AiTaskPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./AiTaskPanel.vue?vue&type=script&setup=true&lang=js"

import "./AiTaskPanel.vue?vue&type=style&index=0&id=07964384&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07964384"]])

export default __exports__